<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UuKsqi/tc-custom/9781644571255.jpg?1685327484682" alt="This image is the cover for the book Laird of Twilight (The Whisky Lairds, Book 1), The Whisky Lairds Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Laird of Twilight (The Whisky Lairds, Book 1), The Whisky Lairds Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A Grandmother's Will and Secrets From the Fairy Realm Bring Love to the Scottish Highlands in <i>Laird of Twilight,</i> a Historical Romance from Susan King</b><br/><br/><i>--Scottish Highlands, 1822--</i><br/><br/>James MacCarran, the new Viscount Struan, has no desire to venture onto the thorny battlefield of marriage. But his grandmother's will issues an ultimatum—marry a Highlander with fairy blood or forfeit his inheritance. Then he meets Elspeth MacArthur. She's beautiful, enchanting—luminous, really—with something mysterious and unique about her.<br/><br/>Yet, Elspeth is keeping an astonishing family secret and spurns the hopeful and handsome Lord Straun, confident he will never accept her situation.<br/><br/>But when an ancient and mystical force portends to reveal the truth behind her secret, Elspeth quickly realizes her only haven is in James' passionate embrace . . . the most dangerous place of all.<br/><br/><b>Publisher Note:</b> Previously published as <i>To Wed a Highland Bride,</i> the story has been edited by the author for today's readers. Readers who appreciate romance set in historical settings with fantasy elements will not want to miss the newly-updated Whisky Lairds Series.<br/><br/><b>The Whisky Lairds Series</b><br/><i>Laird of Twilight<br/>Laird of Secrets<br/>Laird of Rogues</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan King, Sarah Gabriel
      </h2>
      
      <p class="authorDescription body article">Susan King is the bestselling, award-winning author of 22 historical novels and novellas praised for historical accuracy, master storytelling and lyricism. As Susan King and Sarah Gabriel, she has written several historical romances for Penguin Putnam and Avon; as Susan Fraser King, she writes historical fiction, including Lady Macbeth: A Novel, and Queen Hereafter: A Novel of Margaret of Scotland, from Random House. A former college lecturer and founding member of the popular Word Wenches blog, Susan holds graduate degrees in art history and lives in Maryland with her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7efedc8e